import {
    createContext,
    useContext,
    useReducer,
    useMemo,
} from 'react';

import { UMDataReducer } from '@reducers/UMDataReducer';

export const UMDataContext = createContext(null);

export const useUMContext = () => {
    return useContext(UMDataContext);
};

export const UMDataProvider = ({ children }) => {
    const umData = {
        umPlatform: '',
        isUnderMaintenance: false,
        displayUmStartTime: '',
        displayUmEndTime: '',
    };

    const [umDataState, umDataDispatch] = useReducer(
        UMDataReducer,
        umData,
    );

    const valueContext = useMemo(() => [umDataState, umDataDispatch], [umDataState, umDataDispatch]);

    return (
        <UMDataContext.Provider value={valueContext}>
            {children}
        </UMDataContext.Provider>
    );
};
